import * as React from 'react';

export class CommentsLabel extends React.PureComponent {
  render() {
    return <div className="commentslayer-label-container aligned">Comments</div>;
  }
}
